import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _to_consumable_array from "@swc/helpers/src/_to_consumable_array.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { Box, Select, Tooltip } from "@components/mantine";
import { AccessLevel, PrivilegeHolderType } from "@core/api";
import { Locales } from "../../strings/Locales.js";
import { useAccessTableContext } from "./AccessTable.context.js";
export var AccessTableAccessLevelCell = function(param) {
    var id = param.id, accessLevel = param.accessLevel, privilegeHolderType = param.privilegeHolderType, displayName = param.displayName;
    var ref = useAccessTableContext(), getStyles = ref.getStyles, targetDomain = ref.targetDomain, onChange = ref.onChange, value = ref.value, readOnly = ref.readOnly;
    var rootString = privilegeHolderType === PrivilegeHolderType.GROUP ? "GroupsAccessTable" : "APIKeysAccessTable";
    var resourceNamePlural = Locales.formatOrDefault("PrivilegesRows.".concat(targetDomain), {
        defaultTranslation: targetDomain
    }).toLowerCase();
    if (accessLevel === AccessLevel.NONE) {
        return /*#__PURE__*/ _jsx(Tooltip, {
            label: Locales.format("".concat(rootString, ".view.tooltip"), {
                resourceNamePlural: resourceNamePlural
            }),
            position: "top-start",
            children: /*#__PURE__*/ _jsx(Box, {
                children: Locales.format("AccessLevelPicker.option.NONE")
            })
        });
    }
    if (accessLevel === AccessLevel.EDIT_ALL) {
        return /*#__PURE__*/ _jsx(Tooltip, {
            label: Locales.format("".concat(rootString, ".edit.tooltip"), {
                resourceNamePlural: resourceNamePlural
            }),
            position: "top-start",
            maw: 220,
            children: /*#__PURE__*/ _jsx(Box, {
                children: Locales.format("AccessLevelPicker.option.EDIT")
            })
        });
    }
    var ref1;
    var editSelected = (ref1 = value === null || value === void 0 ? void 0 : value.some(function(privilegeHolderThatCanEdit) {
        return privilegeHolderThatCanEdit.id === id;
    })) !== null && ref1 !== void 0 ? ref1 : false;
    return /*#__PURE__*/ _createElement(Select, _object_spread_props(_object_spread({
        w: 130
    }, getStyles("accessLevelSelect")), {
        data: [
            {
                value: "view",
                label: Locales.format("AccessLevelPicker.option.VIEW")
            },
            {
                value: "edit",
                label: Locales.format("AccessLevelPicker.option.EDIT")
            }
        ],
        key: id,
        readOnly: readOnly,
        value: editSelected ? "edit" : "view",
        onChange: function(newSelectValue) {
            var newValue = newSelectValue === "edit" ? _to_consumable_array(value !== null && value !== void 0 ? value : []).concat([
                {
                    id: id,
                    displayName: displayName
                }
            ]) : value.filter(function(v) {
                return v.id !== id;
            });
            onChange(newValue);
        }
    }));
};

//# sourceMappingURL=AccessTableAccessLevelCell.js.map